import { isEqual } from 'lodash';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { ComponentStylingInterface, UserProfileComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

const UserProfileStyling = ({ component, onChange }: ComponentStylingInterface<UserProfileComponentInterface>) => {
  const [currComponent, setCurrComponent] = useState(component);

  const { t } = useTranslation('pagebuilder');
  useEffect(() => {
    setCurrComponent(component);
  }, [component]);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          path: 'customStyling.formBackground',
          type: 'color',
          label: t('pagebuilder:form-background'),
        },
        {
          label: t('pagebuilder:opacity'),
          type: 'slider',
          path: 'customStyling.formOpacity',
          sliderProps: {
            key: 'formOpacity',
            name: 'formOpacity',
            id: 'formOpacity',
            defaultValue: currComponent.customStyling?.formOpacity || 0,
            valueLabelDisplay: 'auto',
            'aria-labelledby': 'continuous-slider',
            scale: (value) => value * 100,
            step: 0.1,
            min: 0,
            max: 1,
          },
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} showTitleAndDescription={false} />;
};
export default React.memo(UserProfileStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
